import React, { RefObject } from 'react'
import { createRegisteredContext } from 'react-singleton-context'

export interface DropdownRootProviderProps {
    dropdownRoot: RefObject<HTMLDivElement | null>
    container: RefObject<HTMLDivElement | null>
}

const defaultContext: DropdownRootProviderProps = {
    container: React.createRef<HTMLDivElement>(),
    dropdownRoot: React.createRef<HTMLDivElement>(),
}

export const DropdownContext = createRegisteredContext<DropdownRootProviderProps>(
    'dropdownRoot',
    defaultContext,
)

export const DropdownRootProvider = DropdownContext.Provider
export const DropdownRootConsumer = DropdownContext.Consumer
